import React, {CSSProperties, memo, ReactNode} from 'react';
import {onClickHandler} from '../../utils/onclick';
import './index.scss';
import DisabledIcon from '../../assets/images/icons/disabled.png';
import {useLocalization} from "../../hooks/localization";
import {Image} from '../Image';
import {NavLink} from 'react-router-dom';
type Props = {
    icon: string;
    isBusy?: boolean;
    hasError?: boolean;
    title?: string;
    to:string;
    children?: ReactNode;
    textStyle?: CSSProperties;
    disabled?: boolean;
    disablePrefix?:boolean;
    containerStyle?:CSSProperties;
};

export const Link = memo(function Link({disablePrefix, icon, to, isBusy, hasError, title, children, textStyle, containerStyle, disabled = false}: Props) {
    const {t} = useLocalization();
    return (
        <div style={{position: 'relative',...containerStyle?containerStyle:{}}}>
            <NavLink to={to}
                className={'open-close-button' + (isBusy ? ' busy' : '')}>
                <img src={DisabledIcon} alt='disabled' className={'position-absolute ' + (disabled ? '' : 'invisible')} />
                <Image src={icon} alt='icon' disablePrefix={disablePrefix}/>
                {
                    renderIf(!!title)(() =>
                        <div className="open-close-button-title">
                            <span style={textStyle}>{title}</span>
                        </div>,
                    )
                }
            </NavLink>
            {
                renderIf(isBusy)(() =>
                    <div className="open-close-button-loading"/>,
                )
            }
            {
                renderIf(hasError)(() =>
                    <div className="open-close-button-loading darker">
                        <span>{t('DEVICE_NOT_REACHABLE')}</span>
                    </div>,
                )
            }
            {children}
        </div>
    );
});
